export default "__VITE_ASSET__CAgSNDO7__"